<div class="ap-table">
    <p class="ap-section-label" *ngIf="section.label">{{ section.label }}</p>
    <div class="ap-table-scroll">
        <table class="ap-table-grid">
            <thead>
                <tr>
                    <th *ngFor="let column of columns; trackBy: trackByIndex">{{ column }}</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let row of rows; trackBy: trackByIndex">
                    <td *ngFor="let cell of row; trackBy: trackByIndex">{{ cell }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
